/**
 * Коды ошибок модуля Libre: нет ключа пользователя на устройстве, шифротекст не
 * расшифровывается, неизвестный узел, предел данных узла, ребёнок у листа, перенос под потомка
 */
export enum EnumLibreError {
  NO_USER_KEY = 'no_user_key',
  CANNOT_DECRYPT = 'cannot_decrypt',
  NODE_NOT_FOUND = 'node_not_found',
  NODE_TOO_LARGE = 'node_too_large',
  LEAF_HAS_NO_CHILDREN = 'leaf_has_no_children',
  MOVE_INTO_ITSELF = 'move_into_itself',
}
